import React, { useMemo } from 'react'
import settings from '../../../components/settings'
import { ConfirmationStep } from '../wizard'
import { badaDefaultProps } from '../../../../types'
import { transformStoreAddress } from '../reducer/transform'

const ConfirmationPage = ({ props }) => {
  const store = useMemo(() => {
    const listResultItem = props.badaProps?.stores?.find(
      (item) =>
        item.id.toString() ===
          props.appointment?.appointment?.storeId?.toString() &&
        !settings.excludedStudioTypes.includes(item.storeType)
    )

    return listResultItem
      ? {
          ...listResultItem,
          address: transformStoreAddress(
            listResultItem.address,
            listResultItem.addressLine1,
            listResultItem.addressLine2,
            listResultItem.city
          ),
        }
      : {}
  }, [props.badaProps?.stores, props.appointment])

  return <ConfirmationStep props={props} selectedStore={store} />
}

ConfirmationPage.defaultProps = {
  ...badaDefaultProps,
}

export default ConfirmationPage
